export default "__VITE_ASSET__DKZahqnM__"